@if (state === 'active') {
  <ng-content></ng-content>
}
